import {
  GET_TAGS,
  GET_TAGS_LIST,
  GET_TAGS_MINIMAL,
  GET_TAG,
  ADD_TAG,
  DELETE_TAG,
  UPDATE_TAG,
  TAGS_LOADING,
  TAG_LOADING,
  CLEAR_CURRENT_TAG,
  SET_TAGS_PAGE
} from '../actions/types';

const initialState = {
  tags: [],                // Lightweight list for table
  minimalTags: [],        // Minimal tags list
  currentTag: null,        // Full tag data for view/edit pages
  loading: false,          // For list loading
  tagLoading: false,       // For single tag loading
  currentPage: 1,          // Current page number
  totalPages: 0,           // Total number of pages
  totalTags: 0,            // Total number of tags
  hasNextPage: false,      // Whether there's a next page
  hasPrevPage: false       // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TAGS_LIST:
      return {
        ...state,
        tags: action.payload.tags || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalTags: action.payload.totalTags || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_TAG:
      return {
        ...state,
        currentTag: action.payload,
        tagLoading: false
      };

    case TAG_LOADING:
      return { ...state, tagLoading: true };

    case CLEAR_CURRENT_TAG:
      return { ...state, currentTag: null, tagLoading: false };

    case ADD_TAG:
      return {
        ...state,
        // Add lightweight version to list
        tags: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            createdBy: action.payload.createdBy,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.tags
        ],
        currentTag: action.payload
      };

    case UPDATE_TAG:
      return {
        ...state,
        // Update in list
        tags: state.tags.map(tag =>
          tag._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                createdBy: action.payload.createdBy,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : tag
        ),
        currentTag: action.payload
      };

    case DELETE_TAG:
      return {
        ...state,
        tags: state.tags.filter(tag => tag._id !== action.payload),
        currentTag: null
      };

    case TAGS_LOADING:
      return { ...state, loading: true };

    case GET_TAGS: // Keep for backward compatibility
      return { ...state, tags: action.payload, loading: false };

    case GET_TAGS_MINIMAL:
      return {
        ...state,
        minimalTags: action.payload,
        loading: false
      };

    case SET_TAGS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
}